import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';


function Warum() {
  return (
    <React.Fragment>
      <Container style={{ minHeight: '0px' }}>
        <Row>
          <Col className='text-center'>
            <h1 className="pb-5">Warum teilnehmen?</h1>
          </Col>
        </Row>
        <Row className="gx-lg-4 gx-xl-5 pb-0">
          <Col className="col-12 col-lg-6">
            <h2 className="pb-2">Ihr Thema verdient Aufmerksamkeit</h2>
            <p>
              Gute Produkte allein reichen nicht aus. Entscheidend ist, dass die richtigen
              Menschen davon erfahren. Die Fachpressetage bieten Ihnen die Möglichkeit, Ihre
              Neuheiten direkt vor relevanten Fachredakteur:innen zu präsentieren – persönlich,
              effizient und ohne Streuverluste.
            </p>

          </Col>
          <Col className="col-12 col-lg-6">
            <h2 className="pb-2">Was Sie erwartet:</h2>
            <ul>
              <li>Multi‑Pressekonferenz mit allen relevanten Fachmedien</li>
              <li>Individuelle Redaktionsgespräche</li>
              <li>Tischmesse für Produkt‑ und Lösungspräsentationen</li>
              <li>Networking mit Entscheider:innen der Automatisierungsbranche</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default Warum;